import DateFormat from "sap/ui/core/format/DateFormat";
import Localization from "sap/base/i18n/Localization";
import Util from "ips/ac/util/Util";
import { AppointmentSeriesDto, DayOfWeek } from "ips/ac/model/api/WinDoFlow.api.types";

const WEEKDAY_REFERENCE_DATES: Record<DayOfWeek, Date> = {
  [DayOfWeek.MONDAY]: new Date(2024, 0, 1),
  [DayOfWeek.TUESDAY]: new Date(2024, 0, 2),
  [DayOfWeek.WEDNESDAY]: new Date(2024, 0, 3),
  [DayOfWeek.THURSDAY]: new Date(2024, 0, 4),
  [DayOfWeek.FRIDAY]: new Date(2024, 0, 5),
  [DayOfWeek.SATURDAY]: new Date(2024, 0, 6),
  [DayOfWeek.SUNDAY]: new Date(2024, 0, 7),
};

export default class AppointmentSeriesFormatter {

  public static formatDescription(oAppointmentSeries: AppointmentSeriesDto, vStart: string | Date, vEnd: string | Date): string {
    if (!oAppointmentSeries) {
      return "";
    }

    const sWeekdays = AppointmentSeriesFormatter.formatWeekdays(oAppointmentSeries.daysOfWeek);
    const sPattern = (oAppointmentSeries.repetitionInterval || 1) > 1
      ? Util.getText("appointmentSeriesRecurrenceDescriptionInterval", [oAppointmentSeries.repetitionInterval, sWeekdays])
      : Util.getText("appointmentSeriesRecurrenceDescriptionWeekly", [sWeekdays]);

    const sTimes = AppointmentSeriesFormatter.formatTimes(vStart, vEnd);

    return sTimes ? `${sPattern} ${sTimes}` : sPattern;
  }

  private static formatWeekdays(arDaysOfWeek: DayOfWeek[] | undefined): string {
    if (!arDaysOfWeek || arDaysOfWeek.length === 0) {
      return "";
    }

    const oDayFormat = DateFormat.getDateInstance({ pattern: "EEEE" });
    const arWeekdayNames = arDaysOfWeek.map((sDay) => oDayFormat.format(WEEKDAY_REFERENCE_DATES[sDay]));

    const oListFormat = new Intl.ListFormat(Localization.getLanguageTag().toString(), { style: "long", type: "conjunction" });
    return oListFormat.format(arWeekdayNames);
  }

  private static formatTimes(vStart: string | Date, vEnd: string | Date): string {
    if (!vStart || !vEnd) {
      return "";
    }

    const oTimeFormat = DateFormat.getTimeInstance({ style: "short" });
    return Util.getText("appointmentSeriesRecurrenceDescriptionTime", [
      oTimeFormat.format(new Date(vStart)),
      oTimeFormat.format(new Date(vEnd)),
    ]);
  }
}
